import { useEffect } from 'react';
export var useCustomEvent = function useCustomEvent(eventName, handler) {
  useEffect(function () {
    document.addEventListener(eventName, handler);
    return function () {
      document.removeEventListener(eventName, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export var dispatchCustomEvent = function dispatchCustomEvent(eventName, detail) {
  document.dispatchEvent(new CustomEvent(eventName, {
    detail
  }));
};